/**
 @ngdoc directive
 @name searchTiles

 @description
 Search Tiles directive

 @usage
 <search-tiles url="${src?.originalRow?.jsonTileURI}" original-row="true" new-template="true"></search-tiles>

 @param {request url with JSON output}  url     - Passing tile model
 @param {boolean / optional}  original-row                 - Settings to avoid opacity on load for original tile view when used in "More like this" function
 @param {boolean}  new-template                 - Displaying new or old template within searchTiles.html


 */

(function() {
    'use strict';

    var searchTiles = function ($templateCache, $http) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                url: "@",
                originalRow: "@",
                newTemplate: "@"
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/searchTiles.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;

                //Using this variable for code readability
                var PAY_TYPE_PER_ANNUM = 320;

                // Availability statuses configuration for code readability
                var AVAILABILITY_STATUS = {
                    POSITIVE: {
                        AVAILABLE: 719,
                        PROSPECTIVE: 5364
                    },
                    NEGATIVE: {

                    },
                    NEUTRAL:{
                        NOT_LOOKING_FOR_WORK: 721,
                        IN_BOOKING: 722,
                        IN_BOOKING_VIA_COMPETITOR: 723,
                        IN_BOOKING_VIA_CLIENT_SUPPLIED: 724,
                        UNKNOWN: 4591,
                        STOPPED: 434496,
                        SELF_SUITED: 434920,
                        ON_HOLD: 434921
                    }
                };

                /**
                 * Pre parse candidate model to make template execution easier to read
                 * @param dataList
                 */
                var parseCandidateModel = function(dataList, objectLabels){
                    for(var objectIdx in dataList){
                        var object = dataList[objectIdx];
                        //Set up job title
                        object.jobTitle = object.currentPreviousJobTitle;
                        if(!object.jobTitle){
                            object.jobTitle = object.desiredJobTitle;
                        }
                        //Set up availability
                        parseAndSetLookupValues(object, objectLabels, ['availability','interimRateType','targetSalaryType']);
                    }
                    return dataList;
                };

                /**
                 * Common method to parse lookup values into an object of {key: often an id, value: display value}
                 */
                var parseAndSetLookupValues = function(object, objectLabels, keyList){
                    for(var keyIdx in keyList){
                        parseAndSetLookupValue(object, objectLabels.lookupValues, keyList[keyIdx] );
                    }
                };

                /**
                 * Common method to parse lookup values
                 */
                var parseAndSetLookupValue = function(object, lookupValues, key){
                    //console.log('parseAndSetLookupValue',object, lookupValues, key);
                    var lookupForObject = object[key];
                    if(lookupForObject) {
                        //console.log('lookupForObject',lookupForObject);
                        var lookupKey = lookupForObject.lookupKey; //key to which lookup value list to use
                        var lookupId = lookupForObject.id; //key to which lookup id we want the value for
                        if(lookupKey && lookupId) {
                            //console.log('lookupKey',lookupKey);
                            var lookupValuesForKey = lookupValues[lookupKey];
                            if (lookupValuesForKey) {
                                //console.log('lookupValuesForKey',lookupValuesForKey);
                                var lookupValue = lookupValuesForKey[lookupId];
                                if (lookupValue) {
                                    //console.log('lookupValue',lookupValue);
                                    //overwrite key with value
                                    lookupForObject.value = lookupValue;
                                } else {
                                    console.warn('unable to find lookup value id:',lookupId,' in lookupValues: ', lookupValues);
                                }
                            } else {
                                console.warn('unable to find lookup values for key: ', lookupKey, 'Available keys are :', Object.keys(lookupValues));
                            }
                        }
                    }
                };

                this.$onInit = function(){
                    _this.ajaxInProgress = true;
                    _this.ajaxState = 'IN_PROGRESS';

                    $http({
                        method: 'GET',
                        url: _this.url
                    }).then(function successCallback(response) {
                        console.log(response);
                        _this.candidates = parseCandidateModel(response.data.dataList, response.data.labels.candidate);
                        _this.candidateLabel = response.data.labels.candidate;
                        _this.commonLabel = response.data.labels.common;

                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                    }, function errorCallback(response) {
                        console.log(response);

                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                    });
                }

                /**
                 * How many decimal places
                 * @param payType
                 * @returns {number}
                 */
                $scope.decimal = function(payType){
                    if (payType == PAY_TYPE_PER_ANNUM){
                        return 0;
                    }else{
                        return 2;
                    }
                };


                /**
                 * Returning colour classes for different types of availability statuses
                 * @param availabilityStatus
                 * @returns {string}
                 */
                $scope.availabilityStatusClass = function(availabilityStatus){
                    for (var key in AVAILABILITY_STATUS.POSITIVE) {
                        if (availabilityStatus == AVAILABILITY_STATUS.POSITIVE[key]) {
                            return 'badge-success';
                        }
                    }
                    for (var key in AVAILABILITY_STATUS.NEGATIVE) {
                        if (availabilityStatus == AVAILABILITY_STATUS.NEGATIVE[key]) {
                            return 'badge-danger';
                        }
                    }
                };
            }]
        };
    };

    searchTiles.$inject = ['$templateCache', '$http'];
    angular.module('app').directive('searchTiles', searchTiles);

}());